import NumberFormat from "react-number-format"

import '../../../assets/style/tablesG.css'
import iconCandado from '../img/tabla/iconCandado.svg'

export const TablaCompras = ({ dataForm, handleChangeItemsTotals, handleChangeItemsName, handleItemSelected }) => {

    const { separacion_miles, separacion_decimales, simbolo, items: detailCompras, pay_for_items = false, total_pagado } = dataForm

    return (
        <table className="table">
            <thead className='p-thead-global'>
                <tr className="text-center TrTitlesTable">
                    <th scope="col">Nombre</th>
                    <th scope="col">Cantidad</th>
                    <th scope="col">Días</th>
                    <th scope="col" className="Col-112">
                        <div className="justify-content-center">
                            P. Unitario
                        </div>
                    </th>
                    <th scope="col" className="Col-112 ColumnGray">
                        <div className="justify-content-center">
                            <img src={iconCandado} alt="no editable" />
                            <span className='ms-1'>Subtotal</span>
                        </div>
                    </th>
                    <th>Seleccionar para pagar</th>
                </tr>
            </thead>
            <tbody>
                {detailCompras?.map((item) => {
                    return (
                        <tr className='TrBodyTable' key={item.id}>
                            <td style={{ paddingLeft: '33px' }} >
                                <div className="AutocompleteListDetail">
                                    <input
                                        className="text-start w-full uppercase cantidades-item"
                                        type="text"
                                        name="nombre"
                                        value={item.nombre}
                                        disabled={dataForm.reading_mode}
                                        onChange={(e) => handleChangeItemsName(e.target.value, item.id)}
                                    />
                                </div>
                            </td>
                            <td>
                                <NumberFormat
                                    className='cantidades-item'
                                    value={item.cantidad}
                                    prefix={''}
                                    onValueChange={(values) => handleChangeItemsTotals(values, 'cantidad', item.id)}
                                    disabled={dataForm.reading_mode}
                                />
                            </td>
                            <td>
                                <NumberFormat
                                    className='cantidades-item'
                                    value={item.dias}
                                    prefix={''}
                                    onValueChange={(values) => handleChangeItemsTotals(values, 'dias', item.id)}
                                    disabled={dataForm.reading_mode}
                                />
                            </td>
                            <td className="TextRight">
                                <NumberFormat
                                    className='cantidades-item'
                                    value={item.precio_unitario}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={`${simbolo} `}
                                    onValueChange={(values) => handleChangeItemsTotals(values, 'precio_unitario', item.id)}
                                    disabled={dataForm.reading_mode}
                                    decimalScale={2}
                                    fixedDecimalScale={2}
                                />
                            </td>
                            <td className="TextRight ColumnGray">
                                <NumberFormat
                                    className='cantidades-item'
                                    value={item.subtotal}
                                    displayType={'text'}
                                    thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={`${simbolo} `}
                                    disabled={dataForm.reading_mode}
                                    decimalScale={2}
                                    fixedDecimalScale={2}
                                />
                            </td>



                            <td className="text-center">
                                {((pay_for_items || total_pagado === 0) && (dataForm.id > 0)) &&
                                    (item.estado_pago !== 'pagada' ?
                                        <input
                                            type="checkbox"
                                            style={{ verticalAlign: 'middle' }}
                                            className="p-normal-checkbox"
                                            onChange={(e) => handleItemSelected(e, item, 'item')}
                                            checked={item.selected}
                                        /> :
                                        <span style={{ color: 'green' }}>
                                            {item.estado_pago}
                                            <i className="bi bi-check-lg"></i>
                                        </span>
                                    )
                                }
                            </td>

                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}